export const TYPES = 'GET_RESTAURANT_TYPES';
export const CITIES = 'GET_CITIES';
export const DISTRICTS = 'GET_DISTRICTS';
export const NEIGHBORHOODS = 'GET_NEIGHBORHOODS';


